module.exports = __webpack_public_path__ + "static/img/image-001.ef636124.jpeg";